import React from "react";

export default function SectionHeading({ eyebrow, title, subtitle, align = "center" }) {
  const alignment =
    align === "center" ? "text-center mx-auto" : "text-left";
  return (
    <div className={`mb-12 max-w-2xl md:mb-16 ${alignment}`}>
      {eyebrow && (
        <p className="mb-3 text-sm font-semibold tracking-widest uppercase text-amber-400">
          {eyebrow}
        </p>
      )}
      <h2 className="text-3xl font-bold tracking-tight text-cream-100 md:text-4xl">
        {title}
      </h2>
      {subtitle && (
        <p className="mt-4 text-lg leading-relaxed text-amber-100/70">{subtitle}</p>
      )}
    </div>
  );
}
